<div class="search-container" #searchContainer>
  <div class="bottom-shadow"></div>
  <div class="top-shadow"></div>
  <div class="search-content">
    @if (prefix()) {
      <div class="sc-prefix"></div>
    }
    <div class="sc-input">
      <input
        class="w-full placeholder-shown:text-ellipsis"
        #searchInput
        type="search"
        placeholder="{{ placeHolder() }}"
        title="{{ placeHolder() }}"
        (keyup.enter)="manualSearch()" />
    </div>
    @if (sufix()) {
      <div class="sc-sufix">
        @if (searchValue() === '') {
          <button type="button" (click)="manualSearch()">
            <svg viewBox="0 0 24 24" id="magnify">
              <path
                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
            </svg>
          </button>
        } @else {
          <button type="button" (click)="clearInput()">
            <svg viewBox="0 -960 960 960" id="magnify-close">
              <path
                d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z" />
            </svg>
          </button>
        }
      </div>
    }
  </div>
  <div
    class="search-helper"
    style="
      width: 288px;
      height: 0px;
      left: 0px;
      top: 52px;
      position: absolute;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      display: inline-flex;
    "></div>
  @if (allowSuggestions() || showHistory()) {
    <ng-template
      #overlayTpl
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="searchContainer"
      [cdkConnectedOverlayOpen]="isOpen()"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayBackdropClass]="'transparent-overlay'"
      [cdkConnectedOverlayWidth]="searchContainer.offsetWidth"
      (backdropClick)="closeOverlay()">
      <menu class="option-list">
        @if (showHistory()) {
          @for (item of historyOptions(); track $index) {
            <li role="menuitem">
              <button (click)="selectedOption(item)">
                <svg viewBox="0 0 24 24" class="icon-menu">
                  <path
                    d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
                </svg>
                <span>
                  {{ item.label }}
                </span>
              </button>
            </li>
          }
        }
        @if (allowSuggestions()) {
          @for (item of suggestionOptions(); track $index) {
            <li role="menuitem">
              <button (click)="selectedOption(item)">
                <svg viewBox="0 0 24 24" class="icon-menu">
                  <path
                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                </svg>
                <span>
                  {{ item.label }}
                </span>
              </button>
            </li>
          }
        }
        @if (
          (showHistory() || allowSuggestions()) &&
          historyOptions().length === 0 &&
          suggestionOptions().length === 0
        ) {
          <li role="menuitem">
            <svg viewBox="0 0 24 24" class="icon-menu">
              <path
                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
            </svg>
            <span>Sin coincidencias</span>
          </li>
        }
      </menu>
    </ng-template>
  }
</div>
<br />
